import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-08d1b216"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "el-form-w3"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "宽", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "unit"
}, "px", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon-link"
}, null, -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "高", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "unit"
}, "px", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input_number = _resolveComponent("el-input-number");
  const _component_el_form_item = _resolveComponent("el-form-item");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_form_item, null, {
    default: _withCtx(() => [_hoisted_2, _createVNode(_component_el_input_number, {
      modelValue: _ctx.inputNumber,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.inputNumber = $event),
      "controls-position": "right"
    }, null, 8, ["modelValue"]), _hoisted_3]),
    _: 1
  }), _hoisted_4, _createVNode(_component_el_form_item, null, {
    default: _withCtx(() => [_hoisted_5, _createVNode(_component_el_input_number, {
      modelValue: _ctx.inputNumber,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.inputNumber = $event),
      "controls-position": "right"
    }, null, 8, ["modelValue"]), _hoisted_6]),
    _: 1
  })]);
}